import DraftedProfileActions from './DraftedProfileActions.component';

export default DraftedProfileActions;
